"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var CurrencyField = function CurrencyField(_ref) {
  var className = _ref.className,
    onAmountChange = _ref.onAmountChange,
    value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    className: className,
    displayType: "input",
    thousandSeparator: true,
    decimalScale: 0,
    fixedDecimalScale: true,
    prefix: "$",
    value: value,
    allowNegative: false,
    onValueChange: onAmountChange
  });
};
CurrencyField.propTypes = {
  className: _propTypes.default.string,
  value: _propTypes.default.number,
  onAmountChange: _propTypes.default.func
};
var _default = CurrencyField;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');